var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("section", [
            _c("div", { staticClass: "fixed-center" }, [_c("b-spinner")], 1),
          ])
        : _vm.tags.length < 1
        ? _c(
            "section",
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.tagModal",
                      modifiers: { tagModal: true },
                    },
                  ],
                  staticStyle: { "margin-top": "4px" },
                },
                [_vm._v("New Tag")]
              ),
            ],
            1
          )
        : _c(
            "section",
            [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "search-header",
                      staticStyle: { "margin-bottom": "0px !important" },
                      attrs: { "align-h": "center" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "my-1", attrs: { md: "6" } },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: { placeholder: "Search tags..." },
                                model: {
                                  value: _vm.searchQuery,
                                  callback: function ($$v) {
                                    _vm.searchQuery = $$v
                                  },
                                  expression: "searchQuery",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.tagModal",
                                  modifiers: { tagModal: true },
                                },
                              ],
                              staticStyle: { "margin-top": "4px" },
                            },
                            [_vm._v("New Tag")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-right", attrs: { md: "4" } },
                        [
                          _c("div", { staticClass: "tag-metrics" }, [
                            _c("span", { staticClass: "metric-item" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.totalTags))]),
                              _vm._v(" Total\n            "),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "metric-item" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.usedTags))]),
                              _vm._v(" In Use\n            "),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "metric-item" }, [
                              _c("strong", [_vm._v(_vm._s(_vm.unusedTags))]),
                              _vm._v(" Unused\n            "),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                ref: "tagsTable",
                attrs: {
                  items: _vm.filteredTags,
                  fields: _vm.fields,
                  hover: "",
                  striped: "",
                  fixed: "",
                },
                on: { "row-clicked": _vm.rowClicked },
                scopedSlots: _vm._u([
                  {
                    key: "cell(usage)",
                    fn: function (data) {
                      return [
                        _vm.getTagUsage(data.item.id).total > 0
                          ? _c("span", { staticClass: "usage-badge" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.getTagUsage(data.item.id).total) +
                                  " uses\n        "
                              ),
                            ])
                          : _c("span", { staticClass: "usage-badge unused" }, [
                              _vm._v("Unused"),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "Edit tag",
                                    expression: "'Edit tag'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.startEdit(data.item)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fi-pencil" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value: "View usage details",
                                    expression: "'View usage details'",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                attrs: { size: "sm", variant: "outline-info" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showTagDetails(data.item)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fi-info" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover.top",
                                    value:
                                      _vm.getTagUsage(data.item.id).total > 0
                                        ? "Cannot delete tag in use"
                                        : "Delete tag",
                                    expression:
                                      "\n              getTagUsage(data.item.id).total > 0\n                ? 'Cannot delete tag in use'\n                : 'Delete tag'\n            ",
                                    modifiers: { hover: true, top: true },
                                  },
                                ],
                                attrs: {
                                  size: "sm",
                                  variant: "outline-danger",
                                  disabled:
                                    _vm.getTagUsage(data.item.id).total > 0,
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmDelete(data.item)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fi-trash" })]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "tagModal",
            title: _vm.editingTag ? "Edit Tag" : "New Tag",
            "ok-disabled": !_vm.tagFormValidation,
          },
          on: { ok: _vm.saveTag, hidden: _vm.resetForm },
        },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.saveTag.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Tag Name", "label-for": "tag-name" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "tag-name",
                      state: _vm.tagFormValidation,
                      placeholder: "Enter tag name...",
                      required: "",
                    },
                    model: {
                      value: _vm.formTagName,
                      callback: function ($$v) {
                        _vm.formTagName = $$v
                      },
                      expression: "formTagName",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-invalid-feedback", [
                    _vm._v(
                      "\n          Tag name must be at least 2 characters and unique\n        "
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.selectedTagModalTitle,
            size: "lg",
            "hide-footer": "",
          },
          model: {
            value: _vm.showDetailsModal,
            callback: function ($$v) {
              _vm.showDetailsModal = $$v
            },
            expression: "showDetailsModal",
          },
        },
        [
          _vm.selectedTag
            ? _c("div", { staticClass: "tag-details" }, [
                _c("div", { staticClass: "usage-summary" }, [
                  _c("h6", [_vm._v("Usage Breakdown")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "usage-stats" }, [
                    _c("div", { staticClass: "usage-stat" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getTagUsage(_vm.selectedTag.id).items)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Items")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-stat" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getTagUsage(_vm.selectedTag.id).menus)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Menu Categories")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-stat" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getTagUsage(_vm.selectedTag.id).packages)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Packages")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-stat" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getTagUsage(_vm.selectedTag.id).units)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Units")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "usage-stat" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.getTagUsage(_vm.selectedTag.id).modifiers)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Modifiers")]),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Confirm Delete",
            "ok-variant": "danger",
            "ok-title": "Delete",
          },
          on: { ok: _vm.deleteTag },
          model: {
            value: _vm.showDeleteModal,
            callback: function ($$v) {
              _vm.showDeleteModal = $$v
            },
            expression: "showDeleteModal",
          },
        },
        [
          _c("p", [
            _vm._v(
              'Are you sure you want to delete the tag "' +
                _vm._s(_vm.tagToDeleteName) +
                '"?'
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v("This action cannot be undone."),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isRequesting
        ? _c("div", { staticClass: "loading-overlay" }, [_c("b-spinner")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n      You don't have any tags in your system yet. "),
      _c("br"),
      _vm._v('Create your first one\n      by clicking "New Tag."\n    '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }